import { applyMiddleware, createStore } from "redux";
import { composeWithDevToolsDevelopmentOnly } from "@redux-devtools/extension";
import monitorReducersEnhancer from "./enhancers/monitor-reducers";
import rootReducer from "../state/reducers";
import eventSyncMiddleware from "./middlewares/event-sync-middleware";
import stateSyncMiddleware from "./middlewares/state-sync-middleware";

const configureStore = (preloadedState) => {
	const middlewares = [eventSyncMiddleware, stateSyncMiddleware];
	const middlewareEnhancer = applyMiddleware(...middlewares);
	const enhancers = [middlewareEnhancer, monitorReducersEnhancer];
	const composedEnhancers = composeWithDevToolsDevelopmentOnly(...enhancers);
	const { hot } = module;

	const store = createStore(rootReducer, preloadedState, composedEnhancers);

	if (process.env.REACT_APP_ENV !== "prod" && hot) {
		hot.accept("../state/reducers", () => store.replaceReducer(rootReducer));
	}

	return store;
};

export default configureStore;
